import { I4BCellType } from '../configurations/i4b-column-configuration';
import { I4bCellConcept } from '../enums/i4b-cell-concept.enum';
import { HeaderType } from '../models/i4b-column-header.model';
import { I4BButtonColumn } from './i4b-button.column';

export class I4BPoEventRulesButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.PO_EVENT_RULES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          enableConditions: [[{ key: 'isEditable', value: true }]],
          visibleConditions: [
            [
              { key: 'canUpdatePoEventRule', value: true },
              { key: 'canDeletePoEventRule', value: true }
            ]
          ],
          singleActions: [
            {
              order: 0,
              key: 'edit',
              label: 'IOT_DICTIONARY.EDIT',
              enableConditions: [[{ key: 'isEditable', value: true }]],
              visibleConditions: [[{ key: 'canUpdatePoEventRule', value: true }]]
            },
            {
              order: 0,
              key: 'configure',
              label: 'IOT_DICTIONARY.CONFIGURE',
              enableConditions: [[{ key: 'isEditable', value: true }]],
              visibleConditions: [[{ key: 'canUpdatePoEventRule', value: true }]]
            },
            {
              order: 0,
              key: 'delete',
              label: 'IOT_DICTIONARY.DELETE',
              enableConditions: [[{ key: 'isActive', value: false }], [{ key: 'isEditable', value: true }]],
              visibleConditions: [[{ key: 'canDeletePoEventRule', value: true }]]
            }
          ]
        }
      },
      { order: 1000 }
    );
  }
}
